import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from './../../services/common.service';
import {ActivatedRoute, Router, Params,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError } from '@angular/router';

import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';


import { FormControl } from '@angular/forms';
import { DoctorService } from '../../services/doctor.service';
declare var google: any;

@Component({
  selector: 'app-nestmenu',
  templateUrl: './nestmenu.component.html',
  styleUrls: ['./nestmenu.component.css']
})
export class NestmenuComponent implements OnInit {

  searchdata: any;
  searchterm: any;
  special = [];
  speci: any;
  timer: any;
  counter = 1;
  menuflagstatus: any;
  loading = false;
  geocoder: any;
  request: { latLng: any; };
  currentlocationString: any;
  public searchControl: FormControl;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  constructor(private commonService: CommonService, private router: Router,
  private doctorService: DoctorService,
  private zone: NgZone) {
    this.commonService.pulsemenuflag.subscribe(x => {
      this.menuflagstatus = x;
    });
    this.commonService.specializationfilterid.subscribe( (x) => {
      this.speci = x;
    });
    if (document.getElementById('js1')) {
      document.getElementById('js1').remove();
      const js1 = document.createElement('script');
      js1.setAttribute('id', 'js1');
      js1.setAttribute('src', './assets/js/jquery-3.2.1.min.js');
      document.body.appendChild(js1);
    }
    if (document.getElementById('js2')) {
    document.getElementById('js2').remove();
    const js2 = document.createElement('script');
    js2.setAttribute('id', 'js2');
    js2.setAttribute('src', './assets/js/webslidemenu.js');
    document.body.appendChild(js2);
    }
    var x = document.getElementById("hidenav");
    var y = document.getElementById("hidenav2");

   }

  ngOnInit() {
    this.getSearchdata();
    this.getSpecialisation();

    var headerfull = document.getElementById("wmsticky");
    var sticylogo = document.getElementById("sticylogo2");
    var menubg = document.getElementById("menub");
    var stickyalign = document.getElementById("sticky3");
    var sticky // = headerfull.offsetTop;

/*    window.onscroll = function() {myFunction()};

  function myFunction() {

  if (window.pageYOffset >= sticky) {
    headerfull.classList.add("sticky");
    sticylogo.classList.add("sticky2");
    menubg.classList.add("menuback");
    stickyalign.classList.add("stickyalign2");
  } else {
    headerfull.classList.remove("sticky");
    sticylogo.classList.remove("sticky2");
      menubg.classList.remove("menuback");
      stickyalign.classList.remove("stickyalign2");
  }
  } */
  }


  UpdateFilter(ev: any) {
    this.commonService.specialisationfilter.next(this.speci);
  }
  getSearchdata() {
    this.commonService.getDoctorSearchdata()
    .subscribe (
      (x) => {
        this.searchdata = x;
      });
  }
  getSpecialisation() {
    this.doctorService.getSpecialisation()
    .subscribe(
      (x) => {
        this.special = x;
      });
  }
  selectedItem(item) {
    if (item.code === 'Enter') {
      this.goToSearch()
    }
  }
  checkEveryMatch(str, element) {
    if ( str.toString().toLowerCase().match(element)) {
      return 1;
    }else {
      return 0;
    }
  }
 
 goToDetail(type_id, url, type) {
      if (type === 'doctor') {
        this.router.navigate(['/pulse/doctordetail/', type_id]);
      }
    }
    goToSearch() {
      const a = typeof this.searchterm;
      if (a === 'object') {
        this.commonService.doctornameflag.next(this.searchterm.title);
        this.router.navigate(['/pulse/doctor']);
      }else if (this.searchterm == undefined) {
          this.commonService.doctornameflag.next('na');
          this.router.navigate(['/pulse/doctor']);
        } else if (this.searchterm == '') {
          this.commonService.doctornameflag.next('na');
          this.router.navigate(['/pulse/doctor']);
        } else {
          this.commonService.doctornameflag.next(this.searchterm);
          this.router.navigate(['/pulse/doctor']);
        }
    }
    /*
    public getLocation() {
      this.loading = true;
      if (navigator.geolocation) {
       navigator.geolocation.getCurrentPosition(
         (pos) => this.setPosition(pos));
      } else {
        this.loading = false;
          console.log('Geolocation is not supported by this browser') ;
      }
   } */
 /*  public  setPosition(position) {
    const lat  = position.coords.latitude ;
    const lon =  position.coords.longitude;
    this.currentLocation = {'lat': lat, 'lon': lon}
    this.loading = false;
    this.commonService.latitude.next(lat);
    this.commonService.longitude.next(lon);
    this.commonService.geosetflag.next(1);
   this.translateMylocation()
    }
    translateMylocation() {
      this.mapsApiLoader.load().then(() => {
        this.loading = true;
        this.geocoder = new google.maps.Geocoder();
        const latlng = new google.maps.LatLng(this.currentLocation.lat, this.currentLocation.lon);
        this.request = {
          latLng: latlng
        };
        this.convertLocation();
      });
    } */
    /* convertLocation() {
      this.loading = false;
        this.geocoder.geocode(this.request, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
                      if (results[0] != null) {
                        const len = results[0].address_components.length;
                        this.zone.run(() => {
                this.currentlocationString = results[0].address_components[results[0].address_components.length - len].short_name
                 + ',' + results[0].address_components[results[0].address_components.length - len + 1].short_name;
             });
             }
             }
        });
     } */
     /*
    ngOnDestroy() {
      this.commonService.specialisationfilter.next(0);
    } */
    bookNest() {
     const flag = 9;
     this.commonService.setActivatepath(flag);
      this.router.navigate(['/nest/booking']);
    }
}
